// src/store/index.jsx
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import commonapi from './services/commonAPI';
import skillmasterapi from './services/SkillMasterAPI';
import dashboardapi from '@/app/services/DashboardAPI';
import skillmanagementapi from '@/app/services/SkillManagementAPI';
import skillAchievementApi from '@/app/services/SkillAchievementAPI';
import internshipapi from '@/app/services/InternshipAPI';
import specialachievementapi from '@/app/services/SpecialAchievementAPI';
import utilapi from '@/app/services/UtilAPI';
import collegeprojectapi from '@/app/services/CollegeProjectAPI';
import jobOrientedSkillApi from '@/app/services/JobOrientedSkillAPI';

import {
  menuAPI,
  profileAPI,
  contactUpdateAPI,
  CommonAPI,
  externalSkillPassportAPI,
  passwordVerificationAPI,
  locationApi,
  NotificationAPI,
} from "@gyandiksha/shared-ui/app/services";

export const store = configureStore({
  reducer: {
    [skillmanagementapi.reducerPath]: skillmanagementapi.reducer,
    [skillAchievementApi.reducerPath]: skillAchievementApi.reducer,
    [internshipapi.reducerPath]: internshipapi.reducer,
    [specialachievementapi.reducerPath]: specialachievementapi.reducer,
    [dashboardapi.reducerPath]: dashboardapi.reducer,
    [utilapi.reducerPath]: utilapi.reducer,
    [collegeprojectapi.reducerPath]: collegeprojectapi.reducer,
    [jobOrientedSkillApi.reducerPath]: jobOrientedSkillApi.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [contactUpdateAPI.reducerPath]: contactUpdateAPI.reducer,
    [commonapi.reducerPath]: commonapi.reducer,
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [skillmasterapi.reducerPath]: skillmasterapi.reducer,
    [externalSkillPassportAPI.reducerPath]: externalSkillPassportAPI.reducer,
    [menuAPI.reducerPath]: menuAPI.reducer,
    [passwordVerificationAPI.reducerPath]: passwordVerificationAPI.reducer,
    [locationApi.reducerPath]: locationApi.reducer,
    [NotificationAPI.reducerPath]: NotificationAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      skillmanagementapi.middleware,
      skillAchievementApi.middleware,
      internshipapi.middleware,
      specialachievementapi.middleware,
      dashboardapi.middleware,
      utilapi.middleware,
      collegeprojectapi.middleware,
      jobOrientedSkillApi.middleware,
      profileAPI.middleware,
      contactUpdateAPI.middleware,
      commonapi.middleware,
      CommonAPI.middleware,
      skillmasterapi.middleware,
      externalSkillPassportAPI.middleware,
      menuAPI.middleware,
      passwordVerificationAPI.middleware,
      locationApi.middleware,
      NotificationAPI.middleware,
    ),
});
setupListeners(store.dispatch);
